import { isLocalHost } from 'utils/env';
const host = window.location.host;
const fandomDomain = isLocalHost() ? 'fandom.com' : host.substring(host.indexOf('.') + 1);
export const verticalData = {
    games: [
        {
            name: 'Leaguepedia',
            url: `https://lol.${fandomDomain}`,
            thumbnail: 'https://static.wikia.nocookie.net/5513b4b8-833d-44f5-9ecc-50d6f9b62204/scale-to-height-down/400',
        },
        {
            name: 'Wowpedia',
            url: `https://wowpedia.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/00e41f99-d72c-4614-ab8a-166cf25c85d1/scale-to-height-down/400',
        },
        {
            name: 'Minecraft Wiki',
            url: `https://minecraft.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/6769471a-e473-4517-b302-ffc439465cd2/scale-to-height-down/400',
        },
        {
            name: 'GTA Wiki',
            url: `https://gta.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/gtawiki/images/f/fb/GTAVCS-Cover.jpg/revision/latest/scale-to-height-down/200?cb=20220311135827',
        },
        {
            name: 'The Last of Us Wiki',
            url: `https://thelastofus.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/ab3efbc7-faf6-4a5b-973a-597f11725cb0/scale-to-height-down/400',
        },
        {
            name: 'Zelda Wiki',
            url: `https://zelda.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/68d3b06a-0811-489a-aa06-e2345b2ef366/scale-to-height-down/400',
        },
        {
            name: 'Pokémon Wiki',
            url: `https://pokemon.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/0ed5e246-ecbe-4cde-ba78-80746204b47a/scale-to-height-down/400',
        },
        {
            name: 'Mortal Kombat Wiki',
            url: `https://mortalkombat.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/898b616c-a47f-47b2-b969-1e9472eedac9/scale-to-height-down/400',
        },
        {
            name: `Marvel's Spider-Man Wiki`,
            url: `https://marvels-spider-man.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/d5ec8941-78fe-41d9-97f7-0fc573bc1197/scale-to-height-down/400',
        },
    ],
    tv: [
        {
            name: 'Witcher Wiki',
            url: `https://witcher.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/890f189e-c5fc-42a7-bbd9-bffe13af1167/scale-to-height-down/400',
        },
        {
            name: 'The Boys Wiki',
            url: `https://the-boys.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/8530e2d4-e195-4f79-9e08-be589861bd67/scale-to-height-down/400',
        },
        {
            name: 'Star Wars Wiki',
            url: `https://starwars.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/6d93af11-075e-44b0-8da3-55659ea8cfb7/scale-to-height-down/400',
        },
        {
            name: 'Avatar Wiki',
            url: `https://avatar.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/38bc4125-97d2-42df-958f-ffc529ff1661/scale-to-height-down/400',
        },
        {
            name: 'Titans Wiki',
            url: `https://titans.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/ad5829ff-b6b6-48b9-8029-6a0ff46f6032/scale-to-height-down/400',
        },
        {
            name: 'Sex Education Wiki',
            url: `https://sexeducation.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/401a1461-7d30-424c-945e-42e379540c93/scale-to-height-down/400',
        },
        {
            name: 'Encyclopedia SpongeBobia',
            url: `https://spongebob.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/a2f81d78-8088-4913-836c-a9c43d6db2da/scale-to-height-down/400',
        },
        {
            name: 'Game of Thrones Wiki',
            url: `https://gameofthrones.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/gameofthrones/images/d/d0/JonSnow8x06.PNG/revision/latest/scale-to-width-down/686?cb=20190714094440',
        },
        {
            name: 'Arrowverse Wiki',
            url: `https://arrow.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/arrow/images/d/d1/Green_Arrow.png/revision/latest/scale-to-width-down/700?cb=20200528020024',
        },
    ],
    movies: [
        {
            name: 'Pixar Wiki',
            url: `https://pixar.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/02244037-d9dc-49d0-baa9-f935e2b322dc/scale-to-height-down/100',
        },
        {
            name: 'Harry Potter Wiki',
            url: `https://harrypotter.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/aad30c25-f98b-4aae-b024-901c456af1ec/scale-to-height-down/100',
        },
        {
            name: 'Wookieepedia',
            url: `https://starwars.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/d29ff5b7-25c3-467a-aad7-3980dc9f5f32/scale-to-height-down/400',
        },
        {
            name: 'Marvel Cinematic Universe',
            url: `https://marvelcinematicuniverse.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/marvelcinematicuniverse/images/9/9a/BlackWidow-EndgameProfile.jpg/revision/latest/scale-to-height-down/400',
        },
        {
            name: 'The Disney Wiki',
            url: `https://disney.${fandomDomain}/`,
            thumbnail: 'http://static.wikia.nocookie.net/7de54604-2615-49f6-aef6-bc75bd65a1e7/scale-to-height-down/400',
        },
        {
            name: 'DC Extended Universe Wiki',
            url: `https://dcextendeduniverse.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/7b2c03ed-3982-4315-b3b8-c1c6386ea33c/scale-to-height-down/400',
        },
        {
            name: 'The One Wiki to Rule Them All',
            url: `https://lotr.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/lotr/images/9/9f/Elrond_of_Rivendell.jpg/revision/latest/scale-to-height-down/200?cb=20130202120854',
        },
        {
            name: 'Hunger Games Wiki',
            url: `https://thehungergames.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/thehungergames/images/d/da/KatnissD13Portrait.jpg/revision/latest/scale-to-height-down/400?cb=20190306042858',
        },
        {
            name: 'Twilight Saga Wiki',
            url: `https://twilightsaga.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/twilightsaga/images/a/a4/Bella-306318_429619423747956_93621998_n.jpg/revision/latest/scale-to-height-down/200?cb=20130824013830',
        },
    ],
    anime: [
        {
            name: 'One Piece Wiki',
            url: `https://onepiece.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/onepiece/images/6/6b/Slide_1_preview.png/revision/latest/scale-to-height-down/100?cb=20210905184758s',
        },
        {
            name: 'Kimetsu no Yaiba Wiki',
            url: `https://kimetsu-no-yaiba.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/kimetsu-no-yaiba/images/0/05/Announcement.png/revision/latest/scale-to-height-down/100?cb=20220213154627',
        },
        {
            name: 'Yu-Gi-Oh! Wiki',
            url: `https://yugioh.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/yugioh/images/b/b5/Yu-Gi-OhToeiLogo.gif/revision/latest/scale-to-height-down/100',
        },
        {
            name: 'Narutopedia',
            url: `https://naruto.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/naruto/images/b/b2/Naruto_shinden.png/revision/latest/scale-to-height-down/100?cb=20180827121701',
        },
        {
            name: 'Superpower Wiki',
            url: `https://powerlisting.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/powerlisting/images/8/85/Mark_grayson.jpg/revision/latest/scale-to-height-down/100?cb=20200302172030',
        },
        {
            name: 'VS Battles Wiki',
            url: `https://vsbattles.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/vsbattles/images/7/77/VS_Battles_Main_Image_3.png/revision/latest/scale-to-height-down/100?cb=20190118175534',
        },
        {
            name: `Attack on Titan Wiki`,
            url: `https://attackontitan.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/shingekinokyojin/images/4/4f/Mikasa_Ackermann_%28Anime%29_character_image.png/revision/latest/scale-to-width-down/200?cb=20210221220718',
        },
        {
            name: `Jujutsu Kaisen Wiki`,
            url: `https://jujutsu-kaisen.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/jujutsu-kaisen/images/2/2f/Character_Slider.png/revision/latest/scale-to-width-down/300',
        },
        {
            name: 'My Hero Academia Wiki',
            url: `https://myheroacademia.${fandomDomain}/`,
            thumbnail: 'https://static.wikia.nocookie.net/bokunoheroacademia/images/5/5a/Deku_WSJ16.png/revision/latest/scale-to-height-down/100?cb=20191216040733',
        },
    ],
};
